import React from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { FaQuestionCircle } from "react-icons/fa";

export const FleetStatPopover = props => (
    <>
        <OverlayTrigger
            trigger="hover"
            placement="top"
            overlay={
                <Popover>
                    <Popover.Header as="h3">
                        {props.title}
                    </Popover.Header>
                    <Popover.Body>
                        {props.body}
                    </Popover.Body>
                </Popover>
            }
            >
            <a href="#">
                <FaQuestionCircle/>
            </a>
        </OverlayTrigger>
    </>
);